import { useStore } from '@bluheadless/ui-logic/src/providers/store'
import { mediaUrl } from '@bluheadless/ui-logic/src/assets'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useCatalogUrl } from '@bluheadless/ui-logic/src/hooks/useCatalogUrl'
import { removeTrailingSlashes } from '@bluheadless/ui-logic/src/utils/url'
import { useCurrency } from '@bluheadless/ui-logic/src/providers/currency'
import NextHead from 'next/head'

const Product = ({ product }) => {
	const { name, description, sku, assets, urlKey, prices, rating, inventory } = product

	const store = useStore()

	const { currency } = useCurrency()

	const {
		catalog: {
			products: {
				rating: { enabled: ratingEnabled },
			},
		},
		richSnippets: {
			product: { brand },
		},
	} = useConfig()

	return (
		<>
			<NextHead>
				<script
					type="application/ld+json"
					dangerouslySetInnerHTML={{
						__html: JSON.stringify({
							'@context': 'https://schema.org',
							'@type': 'Product',
							name,
							image: assets.map((asset) => mediaUrl(asset.image)) || [],
							description,
							sku,
							aggregateRating:
								ratingEnabled && rating?.summary && rating?.count
									? {
											'@type': 'AggregateRating',
											ratingValue: (rating?.summary * 5) / 100 || null,
											ratingCount: rating?.count || 0,
									  }
									: undefined,
							offers: {
								'@type': 'Offer',
								url: removeTrailingSlashes(store.uri) + useCatalogUrl(urlKey)?.as,
								priceCurrency: currency,
								price: prices.final,
								availability: inventory.inStock ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
							},
							brand: {
								'@type': 'Brand',
								name: brand,
							},
						}),
					}}
				/>
			</NextHead>
		</>
	)
}

export default Product
